// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__VRTrD","text":"style_text__Kveqe"};